import { SuccessDialogComponent } from './shared/success-dialog/success-dialog';
import { RefrenceMaterialUploadComponent } from './components/upload-references/upload-references.component';
import { SpeakeruploadComponent } from './components/speaker/managespeakercontent/managespeakercontent.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';

// material modules
import { AppMaterialModule } from './material/material.module';
// import { MatFormFieldModule, MatOption } from '@angular/material';
// import { MatInputModule, MatSelectModule, MatOptionModule } from '@angular/material';
import { AppBootstrapModule } from './bootstrap/bootstrap.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
// import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { isMoment } from 'moment';
import {MatTableModule} from '@angular/material/table';
// components which are used as featured one's have to be declared here
import { SpeakerListModule } from './components/speaker/speaker-list/speaker-list.module';
import { VenueListModule } from './components/venue/venue-list/venue-list.module';
import { SharedModule } from './shared/shared.module';
import { ConfirmationDialog } from './shared/confirm-dialog/confirmation-dialog';
import { DashboardComponent } from './components/dashboard/dashboard.component';

import { EmailPreviewComponent } from './shared/components/email-preview/email-preview.component';


@NgModule({
  declarations: [
    AppComponent,
    SideNavComponent,
    HeaderComponent,
    EmailPreviewComponent,
    FooterComponent,
    ConfirmationDialog,
    DashboardComponent,
    SuccessDialogComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AppBootstrapModule,
    AppMaterialModule,
    AppBootstrapModule,
    // MatInputModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    VenueListModule,
    SpeakerListModule
  ],
  entryComponents: [ConfirmationDialog, SuccessDialogComponent,EmailPreviewComponent],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
